import * as React from 'react';
import {cn} from '../lib/cn';

export const CarouselViewport = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<'div'>
>(({className, ...props}, ref) => (
  <div
    ref={ref}
    data-slot="carousel-viewport"
    className={cn('relative h-full w-full overflow-hidden', className)}
    {...props}
  />
));

CarouselViewport.displayName = 'CarouselViewport';
